'use strict';

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('./util'),
    get = _require.get,
    is = _require.is,
    px = _require.px;

module.exports = function (_ref) {
  var key = _ref.key,
      prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      numberToPx = _ref.numberToPx;
  return function (props) {
    var n = props[prop];
    if (!is(n)) return null;
    var val = get(props, ['theme', key, n].join('.'), n);
    var value = numberToPx ? px(val) : val;

    return (0, _defineProperty3.default)({}, cssProperty || prop, value);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/styled-system/dist/style.js
// module id = 31
// module chunks = 168707334958949